import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6dd62058&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6dd62058&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd62058",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dd62058')) {
      api.createRecord('6dd62058', component.options)
    } else {
      api.reload('6dd62058', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6dd62058&scoped=true", function () {
      api.rerender('6dd62058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/grantAuth/dept/index.vue"
export default component.exports